import { render, staticRenderFns } from "./repairType2.vue?vue&type=template&id=2d6eed31&scoped=true&"
import script from "./repairType2.vue?vue&type=script&lang=js&"
export * from "./repairType2.vue?vue&type=script&lang=js&"
import style0 from "./repairType2.vue?vue&type=style&index=0&id=2d6eed31&lang=scss&scoped=true&"
import style1 from "./repairType2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6eed31",
  null
  
)

export default component.exports